const GenderGroup = {
	en: {
		today: "Today",
		next: "Next 3 Days",
		any: "Any Day"
	},
	es: {
		today: "Hoy",
		next: "En 3 Dias",
		any: "Cualquiera"
	},
	ko: {
		today: "Jodi a",
		next: "Pwochen 3 jou",
		any: "Nenpòt"
	}
};
export default GenderGroup;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/date-group/date-group.language.js